import { useVideos } from '../../../hooks/useVideos';

export const ReelsVideos = () => {
  const { getActiveVideos, loading } = useVideos();
  const activeVideos = getActiveVideos();

  if (loading) {
    return (
      <section id="videos" className="py-20 bg-gradient-to-b from-white to-[#F5F1ED]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#8B6F47] mb-4">Dicas e Procedimentos</h2>
            <p className="text-lg text-gray-600">Carregando...</p>
          </div>
        </div>
      </section>
    );
  }

  if (activeVideos.length === 0) {
    return null;
  }

  // Função para converter URL do Instagram em embed
  const getInstagramEmbedUrl = (url: string) => {
    try {
      // Extrai o código do reel da URL
      // Formatos aceitos:
      // https://www.instagram.com/reel/ABC123/
      // https://www.instagram.com/p/ABC123/
      // https://instagram.com/reel/ABC123/
      const match = url.match(/(?:reel|p)\/([A-Za-z0-9_-]+)/);
      if (match && match[1]) {
        return `https://www.instagram.com/reel/${match[1]}/embed`;
      }
      return null;
    } catch (error) {
      console.error('Erro ao processar URL do Instagram:', error);
      return null;
    }
  };

  return (
    <section id="videos" className="py-20 bg-gradient-to-b from-white to-[#F5F1ED]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#8B6F47] mb-4">Dicas e Procedimentos</h2>
          <p className="text-lg text-gray-600">Acompanhe nossas dicas e procedimentos no Instagram</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {activeVideos.map((video) => {
            const embedUrl = getInstagramEmbedUrl(video.url_reels);
            
            return (
              <div
                key={video.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  {embedUrl ? (
                    <iframe
                      src={embedUrl}
                      className="w-full h-full"
                      frameBorder="0"
                      scrolling="no"
                      allowTransparency={true}
                      allow="encrypted-media"
                      title={video.titulo}
                    />
                  ) : video.thumbnail ? (
                    <a
                      href={video.url_reels}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-full h-full cursor-pointer"
                    >
                      <img
                        src={video.thumbnail}
                        alt={video.titulo}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                        <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                          <i className="ri-play-fill text-[#8B6F47] text-3xl ml-1"></i>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={video.url_reels}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-full h-full cursor-pointer"
                    >
                      <div className="w-full h-full bg-gradient-to-br from-[#8B6F47] to-[#A0826D] flex items-center justify-center">
                        <i className="ri-video-line text-white text-6xl"></i>
                      </div>
                      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                        <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                          <i className="ri-play-fill text-[#8B6F47] text-3xl ml-1"></i>
                        </div>
                      </div>
                    </a>
                  )}

                  {/* Badge do Instagram */}
                  <div className="absolute top-4 right-4 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-full p-2 shadow-lg z-10">
                    <i className="ri-instagram-line text-white text-xl"></i>
                  </div>
                </div>

                {/* Título */}
                <div className="p-4 bg-white">
                  <h3 className="text-base font-semibold text-gray-800 group-hover:text-[#8B6F47] transition-colors duration-300 line-clamp-2">
                    {video.titulo}
                  </h3>
                  <a
                    href={video.url_reels}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-500 mt-1 flex items-center gap-1 hover:text-[#8B6F47] transition-colors cursor-pointer"
                  >
                    <i className="ri-external-link-line"></i>
                    Ver no Instagram
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA para seguir no Instagram */}
        <div className="text-center mt-12">
          <a
            href="https://www.instagram.com/plennitta/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 text-white font-semibold rounded-full hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-instagram-line text-2xl"></i>
            Siga @plennitta no Instagram
          </a>
        </div>
      </div>
    </section>
  );
};
